import Vue from "vue";
import Vuex from "vuex";
// import cart from './modules/cart'
import products from "./modules/products";
import legs from "./modules/legs";
import cushions from "./modules/cushions";
import fabrics from "./modules/fabrics";
import customizer from "./modules/customizer";
import sizes from "./modules/sizes";
import orientations from "./modules/orientations";
import shipping from "./modules/shipping";
import images from "./modules/images";
import options from "./modules/options";
// import { createLogger } from "vuex/plugins";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    // cart,
    products,
    legs,
    cushions,
    fabrics,
    customizer,
    sizes,
    orientations,
    shipping,
    images,
    options
  },
  strict: debug,
});
